import { inject, Injectable } from '@angular/core';
import { DateConverter } from '@shared-helpers/dateConverter';
import { InitialiseManageCardResult } from '@shared-results/payment/InitialiseManageCardResult';
import { InitialisePaymentResult } from '@shared-results/payment/InitialisePaymentResult';
import { ServiceOperationOutcome } from '@shared-results/ServiceOperationOutcome';
import { BaseHttpService } from '@shared-services/base-http-service';
import { MemberService } from '@shared-services/member.service';
import { Observer } from 'rxjs';
import { catchError, map, switchMap, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root' // Single instance provided in root
})
export class PaymentService extends BaseHttpService {
  private paymentUrl = '/account/';

  private memberService = inject(MemberService);

  constructor() { super("PaymentService"); }

  initialisePayment(observerOrNext?: Partial<Observer<InitialisePaymentResult>> | ((value: InitialisePaymentResult) => void)): void {
    let url: string = `${this.paymentUrl}InitialisePayment`;
    let body: string = null;
    let options = this.httpOptions;
    let client = this.http?.get<InitialisePaymentResult>(url, options).pipe(
      timeout(this.httpTimeout),
      map((item) => DateConverter.stringsToDates(item)),
      switchMap((result) => { return this.logErrorIfNotSuccess(url, body, options, result) }),
      catchError(this.errorService?.handleHttpError<InitialisePaymentResult>(url, body, options, this))
    );
    this.addSubscriptions(client, observerOrNext, (result) => {
      if (result?.ServiceOperationOutcome == ServiceOperationOutcome.Success) {
        // Request succeeded
        this.memberService?.cacheMemberData(result?.MemberData);
      }
    });
  }

  initialiseManageCard(observerOrNext?: Partial<Observer<InitialiseManageCardResult>> | ((value: InitialiseManageCardResult) => void)): void {
    let url: string = `${this.paymentUrl}InitialiseManageCard`;
    let body: string = null;
    let options = this.httpOptions;
    let client = this.http?.get<InitialiseManageCardResult>(url, options).pipe(
      timeout(this.httpTimeout),
      map((item) => DateConverter.stringsToDates(item)),
      switchMap((result) => { return this.logErrorIfNotSuccess(url, body, options, result) }),
      catchError(this.errorService?.handleHttpError<InitialiseManageCardResult>(url, body, options, this))
    );
    this.addSubscriptions(client, observerOrNext, (result) => {
      if (result?.ServiceOperationOutcome == ServiceOperationOutcome.Success) {
        // Request succeeded
        this.memberService?.cacheMemberData(result?.MemberData);
      }
    });
  }

}
